import React from "react";
import moment from "moment";
import MUIListItemIcon from "@mui/material/ListItemIcon";
import MUIFileDownloadIcon from "@mui/icons-material/FileDownload";
import MUIMenuItem from "@mui/material/MenuItem";
import CardClass from "../../CardClass";
import DataGrid from "../../DataGrid";
import EmptyState from "../../EmptyState";
import Progress from "../../Progress";
import Menu from "../../Menu";
import Exporter from "../../../Utility/Exporter";

export default class CardUserProductionDetailResults extends CardClass {
  /**
   * Render the content of the card.
   */
  renderContent() {
    if (this.props.isLoading) {
      return <Progress message="Loading Data..." />;
    }

    if (this.props.rows && this.props.rows.length > 0) {
      return (
        <DataGrid
          rows={this.props.rows}
          onClick={this.props.onClick}
          columns={this.props.columns}
          defaultColumnWidths={this.props.defaultColumnWidths}
          enableGroupingPanel={true}
          onGroupingChange={this.props.onGroupingChange}
          grouping={this.props.grouping}
          groupSummaryItems={this.props.groupSummaryItems}
          sorting={this.props.sorting}
          onSortingChange={this.props.onSortingChange}
        />
      );
    } else {
      return <EmptyState line1={"No Data"} />;
    }
  }

  /**
   * Maps display column names to actual row field names
   * based on the export type.
   * @param {string} column
   * @param {string} type
   * @param {object} row
   * @returns {any}
   */
  getExportValue(column, type, row) {
    switch (type) {
      case "invoice production":
        switch (column) {
          case "User":
            return row["userProfileId"] || "";
          case "Worked At":
            return row["workedAt"]
              ? moment.utc(row["workedAt"]).local().format("M/D/YYYY h:mma")
              : "";
          case "Status":
            return (
              row["brightree_invoice.brightree_invoice_status_term_id"] || ""
            );
          case "Followup Status":
            return (
              row["brightree_invoice.invoice_followup_status_term_id"] || ""
            );
          case "Sales Location":
            return (
              row["brightree_invoice.order_activity.sales_location_id"] || ""
            );
          case "Payor Name":
            return row["brightree_invoice.payor_name"] || "";
          case "Invoice #":
            return row["brightree_invoice.id"] || "";
          case "Balance":
            return typeof row["brightree_invoice.balance"] === "number"
              ? new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(row["brightree_invoice.balance"])
              : "";
          default:
            return row[column] || "";
        }

      // Add other types here as needed

      default:
        return row[column] || "";
    }
  }

  /**
   * Renders an export button that allows users to download a CSV file of the table data.
   * The CSV includes renamed column headers and rows with formatted values, including team, queue, location, department, and user details.
   */
  getActions() {
    const handleExport = () => {
      const csvRows = [];

      csvRows.push(this.props.columnNames);

      // Table rows
      this.props.rows.forEach((row) => {
        const csvRow = [];
        this.props.columnNames.forEach((column) => {
          const value = this.getExportValue(
            column,
            this.props.title.toLowerCase(),
            row,
          );
          csvRow.push(value);
        });
        csvRows.push(csvRow);
      });

      const filename = `User Production Detail ${this.props.title} - ${moment(this.props.loadedAt).format("YYYY-MM-DD h mm a")}.csv`;

      Exporter.exportCSV(csvRows, filename);
    };

    return [
      <Menu
        menuItems={[
          <MUIMenuItem
            disabled={
              this.props.isLoading ||
              !this.props.rows ||
              (this.props.rows && this.props.rows.length === 0)
            }
            onClick={handleExport}
          >
            <MUIListItemIcon>
              <MUIFileDownloadIcon fontSize="small" />
            </MUIListItemIcon>
            Export CSV
          </MUIMenuItem>,
        ]}
      ></Menu>,
    ];
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "Results";
  }
}
